import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "role" }
const _hoisted_2 = { class: "role__top" }
const _hoisted_3 = { class: "role__content" }
const _hoisted_4 = { class: "role__cards" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "role__card-wrap" }
const _hoisted_7 = { class: "role__card-title" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "role__image" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "role__bottom" }
const _hoisted_12 = { class: "role__bottom-items" }
const _hoisted_13 = { class: "role__bottom-item" }
const _hoisted_14 = { class: "h2" }
const _hoisted_15 = { class: "role__bottom-item" }
const _hoisted_16 = { class: "role__gender" }

import DecorTitle from "@/components/uikit/DecorTitle.vue";
import UserPoints from "@/components/uikit/UserPoints.vue";
import GreenButton from "@/components/uikit/GreenButton.vue";
import PageLoader from "@/components/uikit/PageLoader.vue";
import { useGameStore } from "@/stores/index";
import { useRouter } from "vue-router";
import { onMounted, ref, watch, computed } from "vue";
import { getImagePath } from "@/utils/image";


export default /*@__PURE__*/_defineComponent({
  __name: 'RoleScreen',
  setup(__props) {

const store = useGameStore();
const router = useRouter();
const gender = ref("male");
const activeRole = ref(store.rolesList.length > 0 ? store.rolesList[0].id : 0);
const isImageLoading = ref(true);

// Выбор роли
const selectRole = async () => {
  await store.selectRole(gender.value, activeRole.value);

  router.push("/grade");
};

// Главное изображение выбранной роли
const selectedRoleImage = computed(() => {
  const role = store.rolesList.find((r) => r.id === activeRole.value);
  if (!role) return "";

  const img = role.images.find((img) => img.gender === gender.value);
  return img ? getImagePath(img.path) : "";
});

// Загрузка изображения
const handleImageLoad = () => {
  isImageLoading.value = false;
};

watch(
  () => store.rolesList,
  (newRoles) => {
    if (newRoles.length > 0) {
      activeRole.value = newRoles[0].id;
    }
  },
  { immediate: true }
);

watch(selectedRoleImage, () => {
  isImageLoading.value = true;
});

onMounted(() => {
  store.getRole();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "role__bg" }, [
      _createElementVNode("img", {
        src: "/images/role-bg.jpg",
        alt: ""
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DecorTitle, {
        title: 'Кто ты в команде?',
        icon: '/images/role-icon-top.svg'
      }),
      _createVNode(UserPoints, {
        count1: _unref(store).playerScore
      }, null, 8, ["count1"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).rolesList, (item, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["role__card", { 'role__card--active': activeRole.value === item.id }]),
            key: i,
            onClick: ($event: any) => (activeRole.value = item.id)
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(item.description), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.images, (image, j) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: j,
                  class: "role__card-image"
                }, [
                  (image.gender == gender.value)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _unref(getImagePath)(image.path),
                        alt: ""
                      }, null, 8, _hoisted_8))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ], 10, _hoisted_5))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(PageLoader, {
          class: _normalizeClass(["loader--image", { 'loader--active': isImageLoading.value }])
        }, null, 8, ["class"]),
        _withDirectives(_createElementVNode("img", {
          src: selectedRoleImage.value,
          alt: "",
          onLoad: handleImageLoad
        }, null, 40, _hoisted_10), [
          [_vShow, !isImageLoading.value]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "role__bottom-title" }, "роль", -1)),
          _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(store).rolesList.find((role) => role.id === activeRole.value)?.name ?? ""), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "role__bottom-title" }, "пол", -1)),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", {
              class: _normalizeClass(["role__gender-item", { 'role__gender-item--active': gender.value === 'male' }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (gender.value = 'male'))
            }, _cache[3] || (_cache[3] = [
              _createElementVNode("div", { class: "role__gender-wrap" }, "он", -1)
            ]), 2),
            _createElementVNode("div", {
              class: _normalizeClass(["role__gender-item", { 'role__gender-item--active': gender.value === 'female' }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (gender.value = 'female'))
            }, _cache[4] || (_cache[4] = [
              _createElementVNode("div", { class: "role__gender-wrap" }, "она", -1)
            ]), 2)
          ])
        ])
      ]),
      _createVNode(GreenButton, { onClick: selectRole }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode("Далее")
        ])),
        _: 1
      })
    ])
  ]))
}
}

})